import headerApis from '../../service/apis/header.js'
import { setCookie, clearCookie } from '../../plugins/helper'
import * as Sentry from '@sentry/browser'
export const ADD_LIST = 'ADD_LIST'
export const USER_INFO = 'USER_INFO'
export const SET_GROUP = 'SET_GROUP'
export const CREATE_GROUP = 'CREATE_GROUP'
export const UPDATE_AGREEMENT = 'UPDATE_AGREEMENT'
export default {
  namespaced: true,
  state: {
    userInfo: {},
    selfGroup: {},
    taskList: [],
    cancelSuccess: false,
    cancelFail: false,
    createBtnLoading: false,
    hasDiscount:false,
    discountInfo:null,
    agreementData:null
  },
  mutations: {
    [USER_INFO] (state, param) {
      state.userInfo = param.data 
    },
    [SET_GROUP] (state, param) {
      state.selfGroup = param
      state.taskList = []
      clearCookie('cur_group')
      setCookie('cur_group', param.groupId, 365)
    },
    [CREATE_GROUP] (state, param) {
      state.selfGroup = param.data
      clearCookie('cur_group')
      setCookie('cur_group', param.data.groupId, 365)
    },
    [UPDATE_AGREEMENT](state, param){
      state.agreementData=param.data.doc_map[50057553]
    },
    updateTaskList (state, payload) {
      state.taskList = payload.response.data
    },
    updataHasDiscount(state,payload){
      state.hasDiscount = payload
    },
    updataDiscountInfo(state,payload){
      state.discountInfo = payload
    },
    setLoadingTrue (state, stateKey) {
      state[stateKey] = true
    },
    setLoadingFalse (state, stateKey) {
      state[stateKey] = false
    }
  },
  actions: {
    getUserInfo (context) {
      headerApis.queryUserInfo().then(function (response) {
        Sentry.configureScope((scope) => {
          scope.setUser({
            'userInfoCallback': response.data
          })
        })
        context.commit(USER_INFO, response)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    createGroup (context) {
      context.commit('setLoadingTrue', 'createBtnLoading')
      headerApis.createGroup().then(function (response) {
        // console.log(response)
        if (response.data) {
          context.commit(CREATE_GROUP, response)
        }
        context.commit('setLoadingFalse', 'createBtnLoading')
      })
        .catch(function (error) {
          console.log(error)
          context.commit('setLoadingFalse', 'createBtnLoading')
        })
    },
    getAgreement(context){
      headerApis.getAgreement().then(response => response.json())
      .then((data)=>{
        context.commit(UPDATE_AGREEMENT, data)
      }).catch(function (error) {
        console.log(error)
      })
    },
    signOff (context, param) {
      headerApis.signOff(param).then(param['callback']())
    },
    queryTaskList ({ commit }, params) {
      headerApis.queryTaskList(params).then(function (response) {
        commit('updateTaskList', { response })
      }).catch(function (error) {
        console.log(error)
      })
    },
    getDiscount({commit},params){
      headerApis.getDiscount(params).then(function(response){
        if(response.data){
          if(response.data.discount != 100){
            commit('updataHasDiscount', true)
            commit('updataDiscountInfo', response.data)
          }else{
            commit('updataHasDiscount', false)
            commit('updataDiscountInfo', null)
          }
        }else{
          commit('updataHasDiscount', false)
          commit('updataDiscountInfo', null)
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    cancelTask ({ commit }, params) {
      headerApis.cancelTask(params).then(function (response) {
        if (response.status === 0) {
          commit('setLoadingTrue', 'cancelSuccess')
        } else {
          commit('setLoadingTrue', 'cancelFail')
        }
      }).catch(function (error) {
        commit('setLoadingTrue', 'cancelFail')
        console.log(error)
      })
    }

  },
  getters: {
    selfGroup: state => state.selfGroup
  }
}
